import { MelodyBaseUrl, HeartbeatsUrl } from './env.js';
import { post } from "./index";
export const ApigetPageconfig = (configPage,params) => post(`${MelodyBaseUrl}pageconfig/listByKeys?configName=${configPage.configName}`, params);

export const ApigetWebUrls = (params) => post(`${MelodyBaseUrl}sysparam/listByCodes`, params);

export const ApigetWebUrlheartbeats = (url, params) => post(url + HeartbeatsUrl, params);
